<template>
  <div>
    <v-row>
      <v-col cols="12">
        <DadataOrgField
          outlined
          v-model="v.name.$model"
          :errorMessages="getValidationErrorText(v.name)"
          :suggestions="suggestions"
          field="name"          
          @suggest="onSelect"
        >
          <template v-slot:label>
            Полное наименование
            <sup :style="labelSupStyles">1</sup>
          </template>
        </DadataOrgField>
      </v-col>
      <v-col cols="6" class="pb-0">
        <DadataOrgField
          v-model="v.ogrn.$model"
          mask="#############"          
          :errorMessages="getValidationErrorText(v.ogrn)"
          label="ОГРН"
          outlined
          :suggestions="suggestions"
          field="ogrn"          
          @suggest="onSelect"
        />
      </v-col>
      <v-col cols="6" class="pb-0">
        <DadataOrgField
          v-model="v.inn.$model"
          mask="##########"
          :errorMessages="getValidationErrorText(v.inn)"
          outlined
          :suggestions="suggestions"
          field="inn"          
          @suggest="onSelect"
        >
          <template v-slot:label>
            ИНН
            <sup :style="labelSupStyles">1</sup>
          </template>
        </DadataOrgField>
      </v-col>
    </v-row>
    <div class="mb-3 text-small-size">
      <sup class="text-small-size" :style="labelSupStyles">1</sup>
      Указанный параметр не используется при поиске
    </div>
  </div>
</template>

<script>
import  DadataOrgField from '@/components/base/DadataOrgField';
import { maxLength, minLength, required } from 'vuelidate/lib/validators';

import { getValidationErrorText, EMOJI, INN } from '@/utils/validate';

export const organizationModel = {
  name: '',
  ogrn: '',
  inn: '',
};

export const organizationValidation = {
  name: {
    required,
    maxLength: maxLength(1000),
    EMOJI,
  },
  ogrn: {
    required,
    minLength: minLength(13),
  },
  inn: {
    required,
    minLength: minLength(10),
    INN: INN(10),
  },
};

const labelSupStyles = {
  color: '#9c1b38',
};

export default {
  name: 'Organization',
  components: {
    DadataOrgField,
  },
  props: {
    v: Object,
  },
  data: () => ({
    suggestions:  [],
    labelSupStyles,
    getValidationErrorText,
  }),
  methods: {
    onSelect: function (item) {
      this.suggestions = [item];
      this.v.name.$model = item.name;
      this.v.inn.$model = item.inn;
      this.v.ogrn.$model = item.ogrn;
    }
  }
};
</script>
